const defaultState = {
  info: 'Выберите знак, чтобы начать игру',
  isAnimation: false,
};

const SET_INFO = 'SET_INFO';
const SET_ANIMATION = 'SET_ANIMATION';

export const infoReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_INFO:
      return { ...state, info: (state.info = action.payload) };
    case SET_ANIMATION:
      return { ...state, isAnimation: (state.info = action.payload) };
    default:
      return state;
  }
};
